import { installSteamSpecials } from './108-steam-specials.mjs';
import { installSteamExpedition } from './109-steam-expedition.mjs';
import { createSteamClock } from './105-steam-clock.mjs';
import { installSteamState } from './89-steam-state.mjs';
import { installSteamLifecycle } from './90-steam-lifecycle.mjs';
import { installSteamGeneration } from './91-steam-generation.mjs';
import { installSteamLaunch } from './92-steam-launch.mjs';
import { installSteamSimulation } from './93-steam-simulation.mjs';
import { installSteamCollisionIndex } from './94-steam-collision-index.mjs';
import { installSteamRewards } from './95-steam-rewards.mjs';
import { installSteamPowerups } from './96-steam-powerups.mjs';
import { installSteamScene } from './97-steam-scene.mjs';
import { installSteamSprites } from './98-steam-sprites.mjs';
import { installSteamFuel } from './99-steam-fuel.mjs';
import { installSteamEffects } from './100-steam-effects.mjs';
import { installSteamPresentation } from './101-steam-presentation.mjs';
import { installSteamRecords } from './103-steam-records.mjs';
/** Assemble only this instance's owners. Nothing is installed on window or shared
 * with the original game. Clock/random streams are injectable through the host seed. */
export function createSteamRuntime(root, seed, requestDraw = () => {}) {
  const clock = createSteamClock(seed);
  const r = {
    root,
    clock,
    now: clock.now,
    random: clock.random,
    visualRand: clock.visualRand,
    requestDraw,
  };
  installSteamLifecycle(r);
  installSteamGeneration(r);
  installSteamLaunch(r);
  installSteamSimulation(r);
  installSteamCollisionIndex(r);
  installSteamRewards(r);
  installSteamPowerups(r);
  installSteamScene(r);
  installSteamSprites(r);
  installSteamFuel(r);
  installSteamEffects(r);
  installSteamPresentation(r);
  installSteamState(r);
  installSteamRecords(r);
  installSteamSpecials(r);
  installSteamExpedition(r);
  return r;
}
